import { Component, Input } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-single-key',
  templateUrl: './userapi-single-key.component.html'
})
export class UserApiSingleKeyComponent extends AbstractUserApiModalComponent {
  @Input() userApi: UserAPI;
}
